import {Component, prop, watch} from 'vue-property-decorator';

@Component({
    template: require('./adjustment.html'),
    components: {}
})
export class Adjustment {
    @prop(Object)
    adjustment;

    @prop(Object)
    diet;

    @prop(Number)
    i;

    field_focus = false;

    getLabelFor(item) {
        let value = this.diet.adjustment_values[item.id];

        if (value === null || value === undefined) {
            return '';
        }

        if (item.data && item.data.selection instanceof Array && item.type == 1 && item.data.selection[value] !== undefined) {
            return item.data.selection[value].name;
        }

        return value;
    }

    isSingleType(type) {
        if (this.adjustment.items.length != 1) {
            return false;
        }

        return this.adjustment.items[0].type == type;
    }

    get classes() {
        return {
            inline_text: this.isSingleType(0),
            field_focus: this.field_focus,
        };
    }

    change_value(item, event) {
        let value = event.target.value;
        if (item.data.max && value >= item.data.max) {
            value = Math.min(value, item.data.max);
        }
        if (item.data.min && value <= item.data.min) {
            value = Math.max(value, item.data.min);
        }

        this.diet.adjustment_values[item.id] = value;
    }
}
